/**
 * @file     home.ts
 * @readme   ../../CLAUDE.md
 * @purpose  English strings for the home page: SEO metadata and page section copy.
 */
export const home = {
  hub: {
    headline: 'Search homes for sale in BC.',
    subhead:
      'Describe the home you want. See the homes that fit and how each price compares.',
    inputLabel: 'Describe the home you want',
    placeholder: 'Describe the home you want',
    submit: 'Find homes',
    emptyHint: 'Type what you want, or tap an example.',
    examplesLabel: 'Examples',
    example1: '3 bed near a SkyTrain under $1.2M',
    example2: 'Condo with a view in Burnaby',
    example3: 'Detached with a suite in Surrey',
    browseMap: 'Browse the map',
    afford: 'See what you can afford',
    trust: 'Built by Ray Rasouli, REALTOR®',
    startOver: 'Start over',
    rent: {
      headline: 'Search rentals in BC.',
      subhead: 'Filter by rent, move-in date and pets. See what owning nearby would cost.',
      inputLabel: 'Search rentals by address, city, or describe a rental',
      placeholder: 'Address, city or describe a rental',
      submit: 'Find rentals',
      example1: '2 bed near SkyTrain under $3,000',
      example2: 'Pet-friendly in Kitsilano',
      example3: 'Furnished, available now',
      browseMap: 'Browse rentals on the map',
      rentOut: 'Rent out your place',
    },
  },
  seo: {
    title: "BC Real Estate Guidance | It's About You",
    description:
      'Calm, data-informed guidance for Vancouver buyers, sellers, and landlords who want clearer decisions, lower regret, and practical next steps.',
    ogTitle: "BC Real Estate Guidance | It's About You",
    ogDescription: 'Understand the market, compare options, and make rational real estate decisions with confidence.'
  },
  hero: {
    eyebrow: "It's About You",
    headline: 'Vancouver\'s housing market is complex, let\'s make it simple',
    subheadline:
      'Most buyers, sellers, and landlords arrive with good intentions and the wrong starting point. Use the journey that fits your situation so the next step is specific instead of generic.'
  },
  video: {
    title: 'A Calm Advisory Approach for a Complex Market',
    description:
      'A short overview of how Relta Real Estate helps buyers, sellers, and landlords avoid expensive mistakes through education, process clarity, and local data.',
    summary: 'Transparent process. Clear numbers. Practical decision support.'
  },
  categories: {
    title: 'Choose your starting point',
    description: 'Pick the journey that fits you best and move straight into the right next step.',
    firstTimeBuyerTitle: 'Buying in Vancouver',
    firstTimeBuyerDescription:
      'Get started, share your budget, timing, and what kind of home you want.',
    firstTimeBuyerActionLabel: 'Help You Buy',
    marketUpdatesTitle: 'Selling Your Home',
    marketUpdatesDescription:
      'Get a seller-focused journey built around pricing, timing, home condition, and your ideal next step.',
    marketUpdatesActionLabel: 'Help You Sell',
    neighborhoodGuidesTitle: 'Find Tenants',
    neighborhoodGuidesDescription:
      'Get tenant-placement guidance for your property without drifting into full property management.',
    neighborhoodGuidesActionLabel: 'Plan Tenant Placement'
  },
  blog: {
    title: 'Practical guides and market insights',
    description:
      'Analysis written for buyers, sellers, and owners making real decisions - not headlines designed to create urgency.',
    ctaLabel: 'Read All Insights'
  },
  newsletter: {
    title: 'Get weekly market clarity',
    subtitle: 'A concise weekly brief with practical signals, not noise.',
    reassurance: 'No spam. Unsubscribe anytime.'
  }
} as const;
